/* Fitts独自：商品ページの計測（共通）。通常の商品ページと動的LP（?view=lp など）の両方で動く（layout/theme.liquid で読み込む）
   - 開いた・最後まで見た・カートに入れた を Googleシート（Fitts_LP計測）に送る。通常ページは商品名に「_通常」を付けて分ける
   - 送るのは「出来事の名前・訪問ID（でたらめな英数字）・ページ名・広告セットID・スマホかPCか」だけ。名前やメールは送らない
   - 同じ訪問で同じ出来事は1回だけ。公開中のテーマ以外（プレビュー）と、自動で動くブラウザ（審査・検索のロボット）からは送らない
     動作確認だけは URL に ftlp_test=1 を付けると送る
   - URL に ftlp_view=1 を付けると、その訪問の間は何も送らない（見る専用。計測シートのリンクに使う）
   - カートの追加情報に「LP閲覧」（商品名）と「_LP訪問ID」を残す → 注文完了のカスタムピクセルが「買った」を送る（通常ページの人も同じ）
   - 動的LPの仕掛けの計測（assets/fitts-lp.js）は window.FTLP.send / track を使う */
(() => {
  if (window.FTLP) return;
  const LOG_URL = 'https://script.google.com/macros/s/AKfycbzcFZYDqpkQfjPyprWGLQY_e8mxxW_Ut7tnIbUKVnmmWblXwzB08TqQSpe_icIucGJvwQ/exec';
  const test = /[?&]ftlp_test=1/.test(location.search);
  const baseName = () => String(window.FTLP_PRODUCT || '').split('｜')[0].trim();
  const pageName = () => baseName() + (window.FTLP_NORMAL ? '_通常' : '');
  const liveTheme = !(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') || test;
  // 見る専用：URLに ftlp_view=1 があれば、その訪問の間は何も送らない（計測シートに載せる確認用のリンク）
  let viewOnly = /[?&]ftlp_view=1/.test(location.search);
  try { if (viewOnly) sessionStorage.setItem('ftlp-view', '1'); else viewOnly = sessionStorage.getItem('ftlp-view') === '1'; } catch (e) { /* 使えない端末 */ }
  const robot = !test && (navigator.webdriver === true || /bot|crawl|spider|slurp|facebookexternalhit|meta-externalagent|headless|lighthouse|preview|google-inspectiontool/i.test(navigator.userAgent || ''));

  let memId = '';
  const visitorId = () => {
    let v = '';
    try { v = localStorage.getItem('ftlp-vid') || ''; } catch (e) { /* 使えない端末 */ }
    if (!/^[a-z0-9]{8,24}$/.test(v)) {
      v = memId || (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
      try { localStorage.setItem('ftlp-vid', v); } catch (e) { /* 使えない端末 */ }
    }
    memId = v;
    return v;
  };
  // 広告から来たか：広告セットID（utm_term）か、Meta広告のクリックの印（fbclid）がURLにあった訪問（同じ訪問の間は覚えておく）
  const fromAd = () => {
    let a = false;
    try { a = /[?&](fbclid|utm_term)=/.test(location.search); } catch (e) { /* 古い端末 */ }
    try { if (a) sessionStorage.setItem('ftlp-ad', '1'); else a = sessionStorage.getItem('ftlp-ad') === '1'; } catch (e) { /* 使えない端末 */ }
    return a;
  };
  const adTerm = () => {
    let t = '';
    try { t = new URLSearchParams(location.search).get('utm_term') || ''; } catch (e) { /* 古い端末 */ }
    try { if (t) sessionStorage.setItem('ftlp-term', t); else t = sessionStorage.getItem('ftlp-term') || ''; } catch (e) { /* 使えない端末 */ }
    return t;
  };

  let memSent = [];
  const send = (ev) => {
    if (!liveTheme || robot || viewOnly || !baseName()) return;
    const key = `${pageName()}:${ev}`;
    let sent = memSent;
    try { sent = JSON.parse(sessionStorage.getItem('ftlp-sent')) || memSent; } catch (e) { /* 使えない端末 */ }
    if (sent.indexOf(key) !== -1) return;
    sent.push(key);
    memSent = sent;
    try { sessionStorage.setItem('ftlp-sent', JSON.stringify(sent)); } catch (e) { /* 使えない端末 */ }
    const body = JSON.stringify({ ev, vid: visitorId(), p: pageName(), t: adTerm(), a: fromAd() ? 1 : 0, m: window.matchMedia('(pointer: coarse)').matches ? 1 : 0 });
    try { fetch(LOG_URL, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body }).catch(() => {}); } catch (e) { /* 送れなくてもページは止めない */ }
  };

  // カートの追加情報（注文の「追加の詳細」に出る）。書き込みは1本ずつ順番に（同時に走ると後の書き込みが前を上書きするため）
  let cartQueue = Promise.resolve();
  const cartAttr = (fn) => {
    cartQueue = cartQueue.then(() => fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const next = fn(cart.attributes || {});
        if (!next || !Object.keys(next).length) return null;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: next }) });
      })
      .catch(() => {}));
  };
  // 仕掛けを触ったことを送り、カートの「LP体験」にも残す（label があるときだけ）
  const track = (ev, label) => {
    send(ev);
    if (!label || !liveTheme || robot || viewOnly) return;
    cartAttr((at) => {
      const list = at['LP体験'] ? at['LP体験'].split('・') : [];
      const text = `${baseName()}：${label}`;
      return list.indexOf(text) === -1 ? { 'LP体験': list.concat(text).join('・') } : null;
    });
  };

  const start = () => {
    if (!baseName()) return;
    send('view');
    if (liveTheme && !robot && !viewOnly) {
      cartAttr((at) => {
        const list = at['LP閲覧'] ? at['LP閲覧'].split('・') : [];
        const next = {};
        if (list.indexOf(baseName()) === -1) next['LP閲覧'] = list.concat(baseName()).join('・');
        if (at['_LP訪問ID'] !== visitorId()) next['_LP訪問ID'] = visitorId();
        return next;
      });
    }
    // 最後まで見た：動的LPは本文のLPの最後の要素、通常ページは商品説明の最後が画面に入ったら
    if ('IntersectionObserver' in window) {
      const lps = document.querySelectorAll('.ftlp');
      const last = lps.length ? lps[lps.length - 1].lastElementChild
        : (() => { const d = document.querySelector('.product-details .rte, .product-details [class*="description"], .product__description'); return d ? d.lastElementChild || d : null; })();
      if (last) {
        const io = new IntersectionObserver((entries) => { if (entries.some((x) => x.isIntersecting)) { send('end'); io.disconnect(); } });
        io.observe(last);
      }
    }
    // カートに入れた：ボタンではなく「カートに入れる通信（/cart/add）」そのものを見張る（Vitalsの画面など、どの道から入れても数える）
    // すぐ購入ボタン（Shop Pay など）はカートを通らないので、ボタンを押したことで数える
    const isAdd = (u) => /\/cart\/add(\.js)?(\?|$)/.test(String(u || ''));
    try {
      const f = window.fetch;
      window.fetch = function (input, init) {
        try { const u = typeof input === 'string' ? input : input && input.url; if (isAdd(u)) send('cart'); } catch (e) { /* 見張りの失敗で通信は止めない */ }
        return f.apply(this, arguments);
      };
      const o = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) { try { if (isAdd(u)) send('cart'); } catch (e) { /* 同上 */ } return o.apply(this, arguments); };
    } catch (e) { /* 古い端末 */ }
    document.addEventListener('submit', (e) => { const f = e.target; if (f && f.action && isAdd(f.action)) send('cart'); }, true);
    document.addEventListener('click', (e) => {
      const t = e.target && e.target.closest ? e.target : e.target && e.target.parentElement;
      if (t && t.closest('.shopify-payment-button')) send('cart');
    }, true);
  };

  window.FTLP = { send, track, pageName };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
